import {DateTime} from "../form-guide/models/date-time";
import {Mode} from "../form-guide/utility/enums/enums";
import {PopupNotificationComponent} from "../request/popup-notification/popup-notification.component";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {IKeyValuePair} from "../interfaces/IKeyValuePair";


export const showAocModal= function(alertModalRef: BsModalRef, modalService: BsModalService) {
  const initialState = {
    alertMode: Mode.Error,
    alertHeader: this.notEligibleUserTitle,
    alertMassage: `You shall have an AOC with status “Active” or "In progress" before Applying for this request.`,
    backLableText: this.backLabelText,
    enableNavigation: true,
    navigateOnExit: false,
    navigationURL: 'workspace',
  };

  alertModalRef = modalService.show(PopupNotificationComponent, {
    initialState,
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  });

  alertModalRef.content.closeBtnName = 'Close';
}

export const getDistinctObjectsFromArray = function(array: any[], uniqueKey: any) {
  const uniqueKeys = [];
  const distinctArray = [];
  array.forEach(el => {
    if (uniqueKeys.includes(el[uniqueKey])) return;
    distinctArray.push(el);
    uniqueKeys.push(el[uniqueKey]);
  });
  return distinctArray;
};

export const copyObject = function(obj: any) {
  return JSON.parse(JSON.stringify(obj));
};


export const scrollToElement = function(elementId: string): void {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

export const getPropertiesValuesArrayFromPropertiesNamesArrayForObject = (propertiesNames: string[], object: any) =>  {
  let array = [];
  propertiesNames.forEach(propertyName => {
    if (object[propertyName]) {
      array.push(object[propertyName]);
    }
  })
  return array;
}

export function isDateEqual(date:Date, targetDate:Date) {
  // Convert both dates to UTC format to ensure accurate comparison
  const currentDate = new Date(date.toUTCString());
  const utcTargetDate = new Date(targetDate.toUTCString());

  // Compare the dates
  return currentDate.getTime() === utcTargetDate.getTime();
}

export function isFutureDate(targetDate:Date) {
  // Convert both dates to UTC format to ensure accurate comparison
  const currentDate = new Date();
  const utcTargetDate = new Date(targetDate.toUTCString());

  // Compare the dates
  return currentDate.getTime() <= utcTargetDate.getTime();
}
export function isEqualToTheDefaultDate(dateTime: any) {
  const DefaultDate = '1900-01-01T00:00:00';
  return dateTime === DefaultDate;
}

export function convertToJustDate(dateTime: DateTime) {
  // Create a new Date object with the same year, month, and day
  console.log(dateTime);
 return new Date(dateTime.date.year, dateTime.date.month, dateTime.date.month);
}

export function sorKeyValuePairByKey(arr: IKeyValuePair[], sortAscending: boolean = true) {
  return arr.sort((a, b) => {
    const keyA = a.Key.toUpperCase();
    const keyB = b.Key.toUpperCase();

    let comparison = 0;
    if (keyA > keyB) {
      comparison = 1;
    } else if (keyA < keyB) {
      comparison = -1;
    }

    return sortAscending ? comparison : -comparison;
  });
}
